module.exports = __webpack_public_path__ + "static/img/zhengxin_modal_success.d72500c9.jpg";